import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from 'app/core/mips/common/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ApiheaderService {

  private static JWT_TOKEN: string = null;
  private static apiHeader: HttpHeaders = (new HttpHeaders()).set('Content-Type', 'application/json');

  constructor(
  ) {
  }


  //Return the API Headers with the Auth token
  public static getHeaders(): HttpHeaders {
    // First try to get the JWT token
    ApiheaderService.JWT_TOKEN = LocalStorageService.getLocalStorageValueBasedOnKeys('MSAL_JWT_TOKEN');

    if (ApiheaderService.JWT_TOKEN) {
      // Use Bearer format with JWT token
      return ApiheaderService.apiHeader.set('Authorization', 'Bearer ' + ApiheaderService.JWT_TOKEN);
    }

    return ApiheaderService.apiHeader;
  }
}
